import $ from 'jquery';
import ProductListGallery from 'utils/productlist_gallery';

export default function ProductCompareUtils() {
  this.productListGallery = new ProductListGallery();
}

function installComparisonCheckboxes($rootElem) {
  $rootElem.on('click', '.comparison-checkbox', function (e) {
    var $checkbox = $(e.currentTarget);
    if ($checkbox.is(':checked')) {
      // Bei mehr als drei selektierten Produkten keine weiteren Häkchen zulassen
      var comparedProductsCount = $('.compare-outer').length;
      if (comparedProductsCount >= 3) {
        $checkbox.prop('checked', false);
      }
      // Scrolling zum Produktvergleich bei Auswahl eines Produkts
      $('html, body').animate({
        scrollTop: $('[name="comparison-container-anchor"]').offset().top
      }, 300);
    }
  });
}

function installComparisonTrashIcon($rootElem) {
  $rootElem.on('click', '.comparison-trash-icon', function (e) {
    var $target = $(e.currentTarget);
    var spanId = $target.attr("id");
    var productId = spanId.substring("trash-icon-".length, spanId.length);
    $(":checkbox[value=" + productId + "]").prop("checked", false);
  });
}

function initDropdownLinks($rootElem) {
  $rootElem.on('click', '.js-product-compare-dropdown-link', function (e) {
    var $target = $(e.currentTarget);
    var oldItemId = $target.data("item-old-id");
    var newItemId = $target.data("item-new-id");
    var currentUrl = window.location.href;
    location.href = currentUrl.replace(oldItemId, newItemId);
  });
}

function initSellingPoints() {
  $("ul.item-selling-points > li > span.truncatable-content").each(function () {
    var element = this;
    if (element.offsetHeight < element.scrollHeight ||
      element.offsetWidth < element.scrollWidth) {
      $(element).closest("li").addClass("truncated");
    }
  });
}

function init() {
  var $document = $(document);
  installComparisonCheckboxes($document);
  installComparisonTrashIcon($document);
}

ProductCompareUtils.prototype = {
  initListing: function () {
    init();
  },
  initCompare: function () {
    init();
    initDropdownLinks($(document));
    initSellingPoints();

  },
  responsive: function (message, on_off) {
    if (on_off) {
      this.productListGallery.responsive(message, on_off);
    }
  }
};


